// Dependencies`
import { Container, Card, Row, Col, Spinner, Tooltip, OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react'; // Import useEffect and useState for the lifecycle methods
import { getJsonData } from './utils.jsx'; // Import getJsonData from the utils module
import React from 'react';
import SimpleTimeSeriesPlot from './SimpleTimeSeriesPlot.jsx'; // Import SimpleTimeSeriesPlot from the SimpleTimeSeriesPlot module

import { get } from 'jquery';

const InfoIcon = ({width=42, height=42}) => (
  <svg width={width} height={height} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.25 29.75H22.75V19.25H19.25V29.75ZM21 15.75C21.4958 15.75 21.9118 15.582 22.2478 15.246C22.5838 14.91 22.7512 14.4947 22.75 14C22.7488 13.5053 22.5808 13.09 22.246 12.754C21.9112 12.418 21.4958 12.25 21 12.25C20.5042 12.25 20.0888 12.418 19.754 12.754C19.4192 13.09 19.2512 13.5053 19.25 14C19.2488 14.4947 19.4168 14.9106 19.754 15.2478C20.0912 15.5849 20.5065 15.7523 21 15.75ZM21 38.5C18.5792 38.5 16.3042 38.0403 14.175 37.121C12.0458 36.2017 10.1938 34.9551 8.61875 33.3813C7.04375 31.8074 5.79717 29.9553 4.879 27.825C3.96084 25.6947 3.50117 23.4197 3.5 21C3.49884 18.5803 3.9585 16.3053 4.879 14.175C5.7995 12.0447 7.04609 10.1926 8.61875 8.61875C10.1914 7.04492 12.0435 5.79833 14.175 4.879C16.3065 3.95967 18.5815 3.5 21 3.5C23.4185 3.5 25.6935 3.95967 27.825 4.879C29.9565 5.79833 31.8086 7.04492 33.3813 8.61875C34.9539 10.1926 36.2011 12.0447 37.1228 14.175C38.0444 16.3053 38.5035 18.5803 38.5 21C38.4965 23.4197 38.0368 25.6947 37.121 27.825C36.2052 29.9553 34.9586 31.8074 33.3813 33.3813C31.8039 34.9551 29.9518 36.2023 27.825 37.1228C25.6982 38.0433 23.4232 38.5023 21 38.5ZM21 35C24.9083 35 28.2188 33.6438 30.9313 30.9313C33.6438 28.2188 35 24.9083 35 21C35 17.0917 33.6438 13.7813 30.9313 11.0688C28.2188 8.35625 24.9083 7 21 7C17.0917 7 13.7813 8.35625 11.0688 11.0688C8.35625 13.7813 7 17.0917 7 21C7 24.9083 8.35625 28.2188 11.0688 30.9313C13.7813 33.6438 17.0917 35 21 35Z" fill="black"/>
  </svg>
);

const PopoverDashboard = (title, subtitle, text, setShow, id) => (
  <Popover id={id}>
      <Popover.Header as="h4">
      <div className="d-flex justify-content-between">
        {title}-{subtitle}
      <a style={{cursor: 'pointer'}}
       onClick={() => setShow(false)}>X</a>
      </div>
      </Popover.Header>
      <Popover.Body>
          {text}
      </Popover.Body>
  </Popover>
);

const HelpIcon = ({title, subtitle, text, id, placement, size}) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const overlay = PopoverDashboard(title, subtitle, text, setShow, id+"-popover");
  //const overlay = tooltip(title, text, id+"-tooltip");
  return(
  <OverlayTrigger placement={placement} overlay={overlay} show={show}>
      <a 
          className="custom-icon"
          onClick={() => setShow(!show)}
          onHover={() => setShow(!show)}
          ref={target}>
          <InfoIcon width={size} height={size}/>
      </a>
  </OverlayTrigger>


)};


const IndexCard = ({ indexLabel, indexName, region="AUS" }) => {
    const [cardData, setCardData] = useState(null);
    const [trendValue, setTrendValue] = useState(0);
    const [units, setUnits] = useState('');
    const isPositive = trendValue > 0;
    const [isLoading, setIsLoading] = useState(true);
    const indexDefinition = getIndexDefinition(indexName);
    //const [indexDefinition, setIndexDefinition] = useState('');
    const [indexSymbol, setIndexSymbol] = useState(hottestDaySymbol({width:27, height:27}));
    console.log("Recieved indexName: ", indexName)
    console.log("Recieved region: ", region)
    console.log("Recieved indexLabel: ", indexLabel)

    
    
    useEffect(() => {
      
      setIsLoading(true); // Start loading
      getJsonData(indexName, region).then(data => {
          setCardData(data);
          if (data && data.trend && data.trend.slope) {
              const total = data.trend.slope.reduce((acc, cur) => acc + cur.value, 0);
              const avg = data.trend.slope.length > 0 ? total / data.trend.slope.length : 0;
              setTrendValue(avg*10);
              console.log("Got data for index: ", indexName, "Region: ", region)
              console.log("Trend Value: ", avg)
          }
          if (data && data.trend && data.trend.units) {
            let unitStr = data.trend.units;
            // replace lst 6 characters with "per decade"  
            unitStr = unitStr.slice(0, -6) + " per decade";
            setUnits(unitStr);
          }
          setIsLoading(false); // Finish loading
          setIndexSymbol(getIndexSymbol(indexName));
          console.log("Index Symbol: ", indexSymbol)
      });
        

        
    }, [indexName, region]);

   


    return (
      <Card className="dashboard-card my-2">
        <div className='card-body'>
          
          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                
              </Spinner>
            </div>
          ) : (
            <Row className="align-items-center">
          <Col xs={2} md={3} className="text-center pl-3 pr-1">
            <div className="index-symbol">
              {indexSymbol && <span>{indexSymbol}</span>}
            </div>
          </Col>
          <Col xs={10} md={9} className="pl-1 pr-1">
            <div className="d-flex align-items-center mb-1">

            <p className="card-title">{indexLabel}</p>
            <HelpIcon title={indexLabel} subtitle={indexName}text={indexDefinition} id={indexName} placement="top" size={20}/>
            
            </div>
            
            
            <div className='trend-box d-flex align-items-center'>
            <div className="trend-item">
              {isPositive ? upArrow({ width: 25, height: 25 }) : downArrow({ width: 25, height: 25 })}
            </div>
            <span className="trend-item trend-text">
              {trendValue > 0 ? '+': ''}{trendValue.toFixed(2)}
            </span>
            <span className="units">{units}</span>
            </div>
          </Col>
        </Row>
          )}
        </div>
      </Card>
    );
};
const getIndexDefinition = (indexName) => {
  switch (indexName.toLowerCase()) {
    case 'tnn':
      return (<p>Let <var>T</var><var>N</var><var><sub>x</sub></var> be the daily minimum temperatures in month <var>k</var>, period <var>j</var>. The maximum daily minimum temperature each month is then <i>TN<sub>x<sub>kj</sub></sub></i> = max(<i>TN<sub>x<sub>kj</sub></sub></i>).</p>
      );
    case 'txx':
      return (<p>Let <var>T</var><var>X</var><var><sub>x</sub></var> be the daily maximum temperatures in month <var>k</var>, period <var>j</var>. The maximum daily maximum temperature each month is then <i>TX<sub>x<sub>kj</sub></sub></i> = max(<i>TX<sub>x<sub>kj</sub></sub></i>).</p>);
    
    case 'prcptot':
      return (<><p class="card-text">Let <i>RR<sub>ij</sub></i> be the daily precipitation amount on day <var>i</var> in period <i>j</i>, then:</p>
      <math display="block">
        <msub>
          <mi>PRCPTOT</mi>
          <mi>j</mi>
        </msub>
        <mo>=</mo>
        <munderover>
          <mo>&#x2211;</mo>
          <mrow class="MJX-TeXAtom-ORD">
            <mi>i</mi>
            <mo>=</mo>
            <mn>1</mn>
          </mrow>
          <mi>I</mi>
        </munderover>
        <msub>
          <mi>RR</mi>
          <mrow>
            <mi>i</mi>
            <mi>j</mi>
          </mrow>
        </msub>
      </math></>);
    case 'rx1day':
      return (<p class="card-text">Let <i>RR<sub>ij</sub></i> be the daily precipitation amount on day <var>i</var> in period <var>j</var>. The maximum 1-day value for period <var>j</var> are <i>Rx1day<sub>j</sub></i> = max (<i>RR<sub>ij</sub></i>)</p>);

    default:
      return null;
  }
};



const upArrow = ({width=25, height=25}) => (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 17L9.5 11L13.5 15L21.5 7" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.5 7H21.5V14" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const downArrow = ({width=25, height=25}) => (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 7L9.5 13L13.5 9L21.5 17" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.5 10V17H14.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const getIndexSymbol = (indexName) => {
    console.log("Index Name: ", indexName.toLowerCase())
    switch (indexName.toLowerCase()) {
        case 'tnn':
            return coldestNightSymbol({width:27+7, height:27+7});
        case 'txx':
            return hottestDaySymbol({width:34+7, height:35+7});
        case 'prcptot':
            return totalPrecipitationSymbol({width:29+7, height:28+7});
        case 'rx1day':
            return dailyPrecipitationSymbol({width:29+7, height:28+7});
        default:
            return null;
    }
};
const coldestNightSymbol = ({width=27, height=27}) => (
  <svg width={width} height={height} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5 1.5C11.9087 3.0913 11.0147 5.24956 11.0147 7.5C11.0147 9.75044 11.9087 11.9087 13.5 13.5C15.0913 15.0913 17.2496 15.9853 19.5 15.9853C21.7504 15.9853 23.9087 15.0913 25.5 13.5C25.5 15.8734 24.7962 18.1935 23.4776 20.1668C22.1591 22.1402 20.2849 23.6783 18.0922 24.5866C15.8995 25.4948 13.4867 25.7324 11.1589 25.2694C8.83115 24.8064 6.69295 23.6635 5.01472 21.9853C3.33649 20.307 2.1936 18.1689 1.73058 15.8411C1.26756 13.5133 1.5052 11.1005 2.41345 8.9078C3.3217 6.71508 4.85977 4.84094 6.83316 3.52236C8.80655 2.20379 11.1266 1.5 13.5 1.5Z" stroke="#333B60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


);

const hottestDaySymbol = ({width=34, height=35}) => (
  <svg width={width} height={height} viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 24.5C20.866 24.5 24 21.366 24 17.5C24 13.634 20.866 10.5 17 10.5C13.134 10.5 10 13.634 10 17.5C10 21.366 13.134 24.5 17 24.5Z" stroke="#3C0E40" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 1.75V3.5M17 31.5V33.25M1.25 17.5H3M31 17.5H32.75M28.137 6.363L26.8997 7.60025M7.10025 27.3997L5.863 28.637M5.863 6.363L7.10025 7.60025M26.8997 27.3997L28.137 28.637" stroke="#3C0E40" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

const totalPrecipitationSymbol = ({width=29, height=28}) => (
  <svg width={width} height={height}viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.66321 16.8618C2.6726 15.8497 1.9253 14.6254 1.47793 13.2817C1.03055 11.938 0.894821 10.5101 1.08103 9.10618C1.26723 7.70226 1.77049 6.35911 2.55267 5.17849C3.33486 3.99787 4.37546 3.01073 5.59565 2.29185C6.81585 1.57296 8.18365 1.14118 9.59543 1.02922C11.0072 0.917249 12.426 1.12803 13.7442 1.64559C15.0625 2.16316 16.2457 2.97393 17.2042 4.0165C18.1627 5.05906 18.8714 6.30609 19.2765 7.66311H21.6632C22.9506 7.66297 24.2038 8.07688 25.2379 8.8437C26.2719 9.61052 27.0319 10.6896 27.4056 11.9215C27.7792 13.1534 27.7468 14.4729 27.313 15.6849C26.8792 16.897 26.067 17.9374 24.9965 18.6524M19.2765 15.6849V23.6849M8.60988 15.6849V23.6849M13.9432 18.3516V26.3516" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

const dailyPrecipitationSymbol = ({width=29, height=28}) => (
  <svg width={width} height={height}viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.66321 16.8618C2.6726 15.8497 1.9253 14.6254 1.47793 13.2817C1.03055 11.938 0.894821 10.5101 1.08103 9.10618C1.26723 7.70226 1.77049 6.35911 2.55267 5.17849C3.33486 3.99787 4.37546 3.01073 5.59565 2.29185C6.81585 1.57296 8.18365 1.14118 9.59543 1.02922C11.0072 0.917249 12.426 1.12803 13.7442 1.64559C15.0625 2.16316 16.2457 2.97393 17.2042 4.0165C18.1627 5.05906 18.8714 6.30609 19.2765 7.66311H21.6632C22.9506 7.66297 24.2038 8.07688 25.2379 8.8437C26.2719 9.61052 27.0319 10.6896 27.4056 11.9215C27.7792 13.1534 27.7468 14.4729 27.313 15.6849C26.8792 16.897 26.067 17.9374 24.9965 18.6524M19.2765 15.6849V23.6849M8.60988 15.6849V23.6849M13.9432 18.3516V26.3516" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

const IndexCardGroup = ({indexCards}) => {
    return (
        <Container fluid>
        <Row>
            {indexCards.map((card, i) => (
                <Col key={i} s={3} md={3} xl={3} xxl={3}
                className={`${
                  i === 0 ? "pr-1 pl-0" :
                  i === 3 ? "pl-1 pr-0" :
                  "px-1"
                }`}>
                <IndexCard 
                key={i}
                indexLabel={card.indexLabel}
                indexName={card.indexName}
                
                />
                </Col>
            ))}
        </Row>

        </Container>
    );
};

export default IndexCardGroup;